$(function () {
  let sliders = $('.js-slider'),
    $window = $(window);

  sliders.each(function (index, element) {
    let $el = $(element);

    if ($el.is('.js-content-slider')) {
      $el.slick({
        lazyLoad: false,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              dots: true,
              arrows: false
            }
          }
        ]
      });

    } else {
      $el.slick({
        lazyLoad: false
      });
    }


  });


  sliders.on('afterChange', function(event, slick, currentSlide){

    // Ensure lazy loading images are loaded
    $window.trigger('scroll');
  });
});



// WEBPACK FOOTER //
// ./src/js/modules/sliders.js